import React from 'react';
import { motion } from 'framer-motion';
import {
  FaTwitter,
  FaInstagram,
  FaDiscord,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
} from 'react-icons/fa';
import nexolveLogo from '../images/nexolvelogo-new.png';
import '../styles/footer.css';

const Footer = () => {
  const footerSocialLinks = [
    { icon: FaTwitter, href: '#' },
    { icon: FaInstagram, href: 'https://www.instagram.com/nexolvetechnologiesindia/' },
    { icon: FaDiscord, href: 'https://discord.com/invite/AaaB9wbPgu' },
    { icon: FaLinkedin, href: 'https://www.linkedin.com/company/nexolvetechnologiesindia/' },
  ];

  const contactInfo = [
    { icon: FaMapMarkerAlt, text: 'Pune, India' },
    { icon: FaPhone, text: '+91 9850908418' },
    { icon: FaEnvelope, text: 'maitreya@nexolvetechnologiesindia.com' },
    { icon: FaClock, text: 'Mon-Fri: 9 AM - 6 PM (IST)' },
  ];

  const quickLinks = [
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Careers', href: '#careers' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <footer className="nexolve-footer">
      <div className="footer-content">
        <div className="footer-column brand-column">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img src={nexolveLogo} alt="Nexolve Logo" className="brand-logo" />
            <p className="brand-tagline">Innovating the Future of Technology</p>
            <p className="brand-description">
              Transforming challenges into opportunities through cutting-edge solutions and innovative thinking.
            </p>
          </motion.div>
        </div>

        <div className="footer-column contact-column">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            <h3>Contact Us</h3>
            {contactInfo.map(({ icon: Icon, text }, index) => (
              <motion.div
                key={index}
                className="contact-item"
                whileHover={{ translateX: 10, color: '#FF6B35' }}
              >
                <Icon className="contact-icon" />
                <span>{text}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="footer-column quick-links-column">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            <h3>Quick Links</h3>
            <div className="quick-links">
              {quickLinks.map(({ name, href }, index) => (
                <motion.a
                  key={index}
                  href={href}
                  className="quick-link"
                  whileHover={{ color: '#FF6B35', scale: 1.05 }}
                >
                  {name}
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>

        <div className="footer-column social-column">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            <h3>Connect With Us</h3>
            <div className="footer-social-icons">
              {footerSocialLinks.map(({ icon: Icon, href }, index) => (
                <motion.a
                  key={index}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  whileHover={{ scale: 1.2, rotate: 10 }}
                >
                  <Icon />
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Nexolve Technology. All Rights Reserved.
        </p>
        <div className="footer-legal">
          <motion.a
            href="https://docs.google.com/document/d/1ewFSmh4KWZP_0mWhPISPgr1RwtjtfGZqOkwYk6adJso/edit?usp=sharing"
            whileHover={{ color: '#FF6B35', scale: 1.05 }}
          >
            Privacy Policy
          </motion.a>
          <motion.a
            href="https://docs.google.com/document/d/157e7ZGeBsghykrXB9hQRxjDTlZadyJN5JY5eNn2mgW4/edit?usp=sharing"
            whileHover={{ color: '#FF6B35', scale: 1.05 }}
          >
            Terms of Service
          </motion.a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;